import { createSlice } from "@reduxjs/toolkit";
const initialState = {
	patientList: null,
  staffList: null
};
const patientSlice = createSlice({
  name: "Patient",
  initialState: initialState,
  reducers: {
    patientListing(state, action) {
      state.patientList = action.payload;
    },
    staffListing(state, action) {
      state.staffList = action.payload;
    }
  }
});
export const patientActions = patientSlice.actions;
export default patientSlice;
